// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".input-box[data-v-df1a3d86]{align-items:center;display:flex;margin-bottom:1rem;margin-top:1rem}.input-box__input[data-v-df1a3d86]{border-radius:.5rem;border-width:1px;height:3rem;width:100%;--tw-border-opacity:1;border-color:#bec1d2;border-color:rgba(190,193,210,var(--tw-border-opacity));padding:1rem}.input-box__label[data-v-df1a3d86]{font-size:1.125rem;line-height:1.75rem}.input-box__input--readonly[data-v-df1a3d86]{outline:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
